export const contractAddresses = {
  KalaKrutToken: "0x9F9601e0288Ca1d23E5A16da9DC98032Cf045eb8",
  TimelockController: "0x98D039d6C8F4F04ac59d1dF2Cd80f408813C3810",
  KalaKrutGovernor: "0xF2a93cF3931e0Ac1FeB800fC14276b39ee154B7A",
  Treasury: "0x352b7E18f131A7C22A96d14d02911f33ABD12C67",
  KalaKrutNFT: "0xE1e5B593de494621Df33dA43728F72C482671775",
  EventTicket: "0x2b2b6D5107C5F309cc6F68C879387a113Eb66bC9",
  Fractionalizer: "0xC1E1b6603c1614A64df3Bc04Ab711Bc7C02e4b44",
  Escrow: "0xC58C10A11B4bAdd8C365325d3C74C60F98658d55",
  ServiceAgreement: "0x0D227D47Dd19d4BeF1f88Cd7BaE3792b477c67a3",
  ContractFactory: "0xCf7Ed3AccA5a467e9e704C703E8D87F634fB0Fc9"
};